import { render } from "./DismissVillagerModal.vue?vue&type=template&id=50b85a8e&scoped=true"
import script from "./DismissVillagerModal.vue?vue&type=script&lang=js"
export * from "./DismissVillagerModal.vue?vue&type=script&lang=js"

import "./DismissVillagerModal.vue?vue&type=style&index=0&id=50b85a8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50b85a8e"]])

export default __exports__